import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_EDITOR_CUSTOM_FORMS_ACTION_TYPE = createNamedActions(
  'system/loanEditorCustomForms',
  {
    SET_FORMS: 'SET_FORMS',
    SET_FORM: 'SET_FORM',
    UPSERT_FORM: 'UPSERT_FORM',
    REMOVE_FORM: 'REMOVE_FORM',
    SET_LOADING: 'SET_LOADING',
    RESET: 'RESET',
  },
);
